import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';

export type AuthStatus = 'idle' | 'initializing' | 'loading' | 'authenticated' | 'error';

export type AuthState = {
  accessToken: string | null;
  status: AuthStatus;
  initialized: boolean;
  refreshing: boolean;
  error: string | null;
};

export const initialAuthState: AuthState = {
  accessToken: null,
  status: 'idle',
  initialized: false,
  refreshing: false,
  error: null,
};

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.initializeRequested, (state) => ({
    ...state,
    status: 'initializing' as const,
    error: null,
  })),
  on(AuthActions.initializeSucceeded, (state, { accessToken }) => ({
    ...state,
    accessToken,
    status: accessToken ? ('authenticated' as const) : ('idle' as const),
    initialized: true,
    error: null,
  })),
  on(AuthActions.initializeFailed, (state, { error }) => ({
    ...state,
    accessToken: null,
    status: 'error' as const,
    initialized: true,
    error,
  })),
  on(AuthActions.loginRequested, (state) => ({
    ...state,
    status: 'loading' as const,
    error: null,
  })),
  on(AuthActions.loginSucceeded, (state, { token }) => ({
    ...state,
    accessToken: token.accessToken ?? null,
    status: 'authenticated' as const,
    initialized: true,
    error: null,
  })),
  on(AuthActions.loginFailed, (state, { error }) => ({
    ...state,
    accessToken: null,
    status: 'error' as const,
    initialized: true,
    error,
  })),
  on(AuthActions.refreshRequested, (state) => ({
    ...state,
    refreshing: true,
  })),
  on(AuthActions.refreshSucceeded, (state, { token }) => ({
    ...state,
    accessToken: token.accessToken ?? null,
    status: 'authenticated' as const,
    refreshing: false,
    error: null,
  })),
  on(AuthActions.refreshFailed, (state, { error }) => ({
    ...state,
    accessToken: null,
    status: 'error' as const,
    refreshing: false,
    error,
  })),
  on(AuthActions.sessionCleared, () => ({
    ...initialAuthState,
    initialized: true,
  })),
);
